export default () => ({
  root: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    minHeight: '100%'
  }
})
